import React from 'react'
import { useTranslation } from "react-i18next";

const Tr = (props) => {
    const { t } = useTranslation();
    const rq = props.rq;
    const tx = rq.draw_transaction || rq.drawTransaction || null;

    return (
        <tr>
            <td>{rq.id}</td>
            <td>{tx ? tx.order_no : '-'}</td>
            <td>{rq.amount_cny}</td>
            <td>{rq.wechat_transaction_id || '-'}</td>
            <td><span className={`badge badge-${rq.state}`}>{t(`refund_queue.state_${rq.state}`, rq.state || '')}</span></td>
            <td>{rq.created_at ? (new Date(rq.created_at)).toLocaleString() : '-'}</td>
            <td>{rq.refunded_at ? (new Date(rq.refunded_at)).toLocaleString() : '-'}</td>
            <td>
                {rq.state === 'pending'
                    ? <button className="action-button action-button-complete" onClick={() => props.onComplete(rq.id)}>{t('refund_queue.complete')}</button>
                    : '-'}
            </td>
        </tr>
    )
}

export default Tr
